import { render, staticRenderFns } from "./TicketSidebar.vue?vue&type=template&id=1ca66a11&scoped=true"
import script from "./TicketSidebar.vue?vue&type=script&lang=js"
export * from "./TicketSidebar.vue?vue&type=script&lang=js"
import style0 from "./TicketSidebar.vue?vue&type=style&index=0&id=1ca66a11&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca66a11",
  null
  
)

export default component.exports